module.exports = __webpack_public_path__ + "static/media/lifeline_step_4.ee84189f.png";